<template>
  <div>
    <div
      class="page-header clear-filter d-flex justify-content-center align-items-center"
      filter-color="dark"
    >
      <parallax class="page-header-image" style="background-color:#26a23e"></parallax>
      <div class="content-center">
        <div class="container">
          <div class="content-center brand">
            <h1 class="h1-seo">Servicios del Departamento de Desarrollo</h1>
          </div>
        </div>
      </div>
      <vue-particles color="#bbbbbb" :particleOpacity="0.5" :lineOpacity="0.3" :clickEffect="false"></vue-particles>
    </div>

    <div id="technology-department" class="section section-services">
      <div class="container">
        <div class="section-story-overview">
          <div class="row">
            <div class="col-md-8 ml-auto mr-auto text-center">
              <h3>Tecnologías que dominamos:</h3>
            </div>
            <div class="col-12">
              <ul class="grid pt-0">
                <grid-item styles="xs rounded no-border" no-margin @click.native="goto('https://www.typescriptlang.org/')">
                  <template>
                    <img src="img/tech/ts.png" alt="TypeScript" class="tech-img" />
                  </template>
                </grid-item>
                <grid-item styles="xs rounded no-border" no-margin @click.native="goto('https://angular.io/')">
                  <template>
                    <img src="img/tech/angular.png" alt="Angular" class="tech-img" />
                  </template>
                </grid-item>
                <grid-item styles="xs rounded no-border" no-margin @click.native="goto('https://es.reactjs.org/')">
                  <template>
                    <img src="img/tech/react.png" alt="React" class="tech-img" />
                  </template>
                </grid-item>
                <grid-item styles="xs rounded no-border" no-margin @click.native="goto('https://vuejs.org/')">
                  <template>
                    <img src="img/tech/vue.png" alt="Vue.js" class="tech-img" />
                  </template>
                </grid-item>
                <grid-item styles="xs rounded no-border" no-margin @click.native="goto('https://nodejs.org/')">
                  <template>
                    <img src="img/tech/node.png" alt="NodeJS" class="tech-img" />
                  </template>
                </grid-item>
                <grid-item styles="xs rounded no-border" no-margin @click.native="goto('https://expressjs.com/')">
                  <template>
                    <img src="img/tech/express.png" alt="Express" />
                  </template>
                </grid-item>
                <grid-item styles="xs rounded no-border" no-margin @click.native="goto('https://sequelize.org/')">
                  <template>
                    <img src="img/tech/sequelize.png" alt="Sequelize" class="tech-img" />
                  </template>
                </grid-item>
                <grid-item styles="xs rounded no-border" no-margin @click.native="goto('https://ionicframework.com/')">
                  <template>
                    <img src="img/tech/ionic.png" alt="Ionic" class="tech-img" />
                  </template>
                </grid-item>
                <grid-item styles="xs rounded no-border" no-margin @click.native="goto('https://www.ruby-lang.org/')">
                  <template>
                    <img src="img/tech/ruby.png" alt="Ruby" class="tech-img" />
                  </template>
                </grid-item>
                <grid-item styles="xs rounded no-border" no-margin @click.native="goto('https://rubyonrails.org/')">
                  <template>
                    <img src="img/tech/rails.png" alt="Ruby On Rails" class="tech-img" />
                  </template>
                </grid-item>
                <grid-item styles="xs rounded no-border" no-margin @click.native="goto('https://www.python.org/')">
                  <template>
                    <img src="img/tech/python.png" alt="Python" class="tech-img" />
                  </template>
                </grid-item>
                <grid-item styles="xs rounded no-border" no-margin @click.native="goto('https://www.php.net/')">
                  <template>
                    <img src="img/tech/php.png" alt="PHP" class="tech-img" />
                  </template>
                </grid-item>
                <grid-item styles="xs rounded no-border" no-margin @click.native="goto('https://www.mysql.com/')">
                  <template>
                    <img src="img/tech/mysql.png" alt="MySQL" class="tech-img" />
                  </template>
                </grid-item>
                <grid-item styles="xs rounded no-border" no-margin @click.native="goto('https://www.postgresql.org/')">
                  <template>
                    <img src="img/tech/postgresql.png" alt="PostgreSQL" class="tech-img" />
                  </template>
                </grid-item>
                <grid-item styles="xs rounded no-border" no-margin @click.native="goto('https://www.java.com/')">
                  <template>
                    <img src="img/tech/java.png" alt="Java" class="tech-img" />
                  </template>
                </grid-item>
                <grid-item styles="xs rounded no-border" no-margin @click.native="goto('https://www.android.com/')">
                  <template>
                    <img src="img/tech/android.png" alt="Android" class="tech-img" />
                  </template>
                </grid-item>
                <grid-item styles="xs rounded no-border" no-margin @click.native="goto('https://developer.apple.com/swift/')">
                  <template>
                    <img src="img/tech/swift.png" alt="Swift" class="tech-img" />
                  </template>
                </grid-item>
                <grid-item styles="xs rounded no-border" no-margin @click.native="goto('https://aws.amazon.com/')">
                  <template>
                    <img src="img/tech/aws.png" alt="Amazon Web Services" class="tech-img" />
                  </template>
                </grid-item>
                <grid-item styles="xs rounded no-border" no-margin @click.native="goto('https://jitsi.org/')">
                  <template>
                    <img src="img/tech/jitsi.png" alt="Jitsi" class="tech-img" />
                  </template>
                </grid-item>
              </ul>
            </div>
          </div>
        </div>
        <!-- <div class="row">
          <div class="col-12 text-center">
            <h2 class="title">Servicios del Departamento de Desarrollo</h2>
          </div>
        </div> -->
        <two-columns position-text="left" centered>
          <template slot="title">
            <h3>Desarrollo de software a medida</h3>
          </template>
          <template>
            <p
              class="description text-justify"
            >Diseñamos y desarrollamos programas o software a medida, según necesidades, intereses, sector de actividad, número de usuarios, etc.</p>
            <p
              class="description text-justify"
            >Aplicaciones personalizadas y adaptadas en función de los objetivos y las necesidades que se pretenden cubrir.</p>
          </template>
          <template slot="right-text">
            <img src="svg/dev_focus.svg" class="img-fluid py-3" alt="access-control" />
          </template>
        </two-columns>

        <two-columns centered>
          <template slot="title">
            <h3>Consultoría</h3>
          </template>
          <template>
            <p
              class="description text-justify"
            >Analizamos las metas del cliente, el mercado y público objetivo, el tiempo y dinero disponible, y tomando en cuenta todos los factores, te proponemos soluciones.</p>
          </template>
          <template slot="right-text">
            <img src="svg/co-workers.svg" class="img-fluid py-3" alt="access-control" />
          </template>
        </two-columns>

        <two-columns position-text="left" centered>
          <template slot="title">
            <h3>Desarrollo de aplicaciones móviles</h3>
          </template>
          <template>
            <p
              class="description text-justify"
            >Nuestro servicio de desarrollo de aplicaciones móviles va desde el diseño de la interfaz de usuario hasta el lanzamiento final de la aplicación.</p>
            <p
              class="description text-justify"
            >Utilizamos lenguajes de programación modernos para crear aplicaciones iOS, Android e híbridas.</p>
            <p
              class="description text-justify"
            >Combinamos la experiencia del usuario de la aplicación nativa con el rápido ciclo de desarrollo de las aplicaciones híbridas.</p>
          </template>
          <template slot="right-text">
            <img src="svg/mobile_dev.svg" class="img-fluid py-3" alt="access-control" />
          </template>
        </two-columns>

        <two-columns centered>
          <template slot="title">
            <h3>Desarrollo de apps web</h3>
          </template>
          <template>
            <p
              class="description text-justify"
            >Ofrecemos servicio de desarrollo web, desde el diseño y desarrollo de los prototipos hasta el lanzamiento y mantenimiento del producto.</p>
            <p
              class="description text-justify"
            >Desarrollamos aplicaciones web progresivas que se ejecutan perfectamente en equipos de escritorio, laptops y dispositivos móviles..</p>
            <p
              class="description text-justify"
            >Utilizamos tecnologías escalables, seguras, rápidas y confiables que son la base de las aplicaciones que creamos.</p>
          </template>
          <template slot="right-text">
            <img src="svg/web_dev.svg" class="img-fluid py-3" alt="access-control" />
          </template>
        </two-columns>

        <div class="section-story-overview pt-0">
          <div class="row">
            <div class="col-md-9 mx-auto">
              <h4
                class="description text-center"
              >Tenemos soluciones integrales de la más alta tecnología y sofisticación para el óptimo y confortable manejo.</h4>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { GridItem } from "@/components";
export default {
  name: "technology-services",
  bodyClass: "services-page",
  components: {
    GridItem
  },
  data() {
    return {
      social: {
        title: 'Servicios del Departamento de Desarrollo | Proyectos SEES',
        description: 'En Proyectos SEES brindamos solucionesintegrales en tecnología, eficiencia energética, seguridad electrónica y mantenimiento IT.',
        image: 'https://proyectosees.com/img/ees-icon.png'
      }
    };
  },
  head: {
    title: {
      inner: 'Servicios del Departamento de Desarrollo'
    },
    // Meta tags
    meta() {
      return [
        { n: 'description', c: this.social.description, id: 'desc' },
        // Twitter
        { n: 'twitter:card', c: 'summary', id: 'twtca' },
        // { n: 'twitter:site', c: '@username', id: 'twtsi' },
        { n: 'twitter:title', c: this.social.title, id: 'twtti' },
        { n: 'twitter:description', c: this.social.description, id: 'twtde'},
        // { n: 'twitter:creator', c: '@username', id: 'twtcr' },
        { n: 'twitter:image', c: this.social.image, id: 'twtim' },
        // Google+ / Schema.org
        { itemprop: 'name', c: this.social.title, id: 'gglna' },
        { itemprop: 'description', c: this.social.description, id: 'gglde' },
        { itemprop: 'image', c: this.social.image, id: 'gglim' },
        // Facebook / Open Graph
        { p: 'og:title', c: this.social.title, id: 'ogtit' },
        { p: 'og:type', c: 'website', id: 'ogtyp' },
        { p: 'og:url', c: 'https://proyectosees.com/technology-services/', id: 'ogurl' },
        { p: 'og:image', c: this.social.image, id: 'ogima' },
        { p: 'og:description', c: this.social.description, id: 'ogdes' },
        { p: 'og:site_name', c: 'Proyecto SEES', id: 'ogsit' },
        // { p: 'fb:app_id', c: '123456789' },
      ]
    },
    // link tags
    link: [
      { rel: 'canonical', href: 'https://proyectosees.com/technology-services/', id: 'canonical' },
      { rel: 'alternate', href: 'https://proyectosees.com/technology-services/', hreflang: "es-419", id: 'alter' },
    ],
  },
  methods: {
    goto: url => {
      window.open(url, '_blank');
    }
  }
};
</script>
<style>
</style>
